import { Input } from 'antd';
import React from 'react';
import './style.scss';
interface IProps {
    minLength?: number;
    maxLength?: number;
    placeholder?: string;
    field: any;
    onBlur?: () => void;
    onFocus?: () => void;
    addonAfter?: React.ReactNode | null;
    min?: number;
    max?: number;
    height?: number | string;
    defaultValue?: number;
    disabled?: boolean;
    isDecimal?: boolean;
    className?: string;
    allowClear?: boolean;
    suffix?: React.ReactNode | null;
}

const InputOnlyNumber: React.FC<IProps> = ({
    field,
    minLength,
    maxLength,
    placeholder,
    onBlur,
    onFocus,
    addonAfter,
    min,
    max = 0,
    height,
    defaultValue,
    disabled = false,
    isDecimal = false,
    className,
    allowClear = false,
    suffix,
}) => {
    const onKeyPress = (e: React.KeyboardEvent) => {
        const specialCharRegex = new RegExp('[0-9]');
        const specialCharRegexDecimal = new RegExp('[0-9.]');
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        const checkSpecial = isDecimal ? !specialCharRegexDecimal.test(pressedKey) : !specialCharRegex.test(pressedKey);
        if (checkSpecial || pressedKey === ' ' || (max !== 0 && Number(pressedKey) > max)) {
            e.preventDefault();
            return;
        }
    };

    const disabledCopyPaste = (e: React.KeyboardEvent) => {
        e.preventDefault();
        return false;
    };

    return (
        <Input
            className={`input-only-number ${className}`}
            onBlur={onBlur}
            onFocus={() => {
                if (onFocus) onFocus();
            }}
            addonAfter={addonAfter}
            minLength={minLength}
            maxLength={maxLength}
            min={min}
            max={max}
            placeholder={placeholder}
            {...field}
            controls={false}
            onKeyPress={onKeyPress}
            // inputMode="none"
            // pattern="[0-9]*"
            defaultValue={defaultValue}
            disabled={disabled}
            onPaste={disabledCopyPaste}
            rules={[{ type: 'number' }]}
            allowClear={allowClear}
            suffix={suffix}
        />
    );
};

export default React.memo(InputOnlyNumber);
